import {createSelector, createSlice, PayloadAction} from 'lowkey-component';

import {RootState} from '@store/rootReducer';

export type TrainingModal = {
  id: string;
  isOpen: boolean;
};

export interface trainingState {
  trainingModals: {[id: string]: TrainingModal};
  currentId: string | undefined;
}

const initialValues: trainingState = {
  trainingModals: {},
  currentId: undefined,
};

export const selectTrainingState = (state: RootState) => {
  return state.training;
};

const selectTrainingModals = createSelector(
  selectTrainingState,
  ({trainingModals}) => trainingModals,
);

const selectCurrentId = createSelector(
  selectTrainingState,
  ({currentId}) => currentId,
);

const selectTrainingModalId = (id: string) =>
  createSelector(selectTrainingModals, (modals) => {
    const [, ret] =
      Object.entries(modals).find(([_, modal]) => modal.id === id) || [];
    return ret;
  });
const trainingSlice = createSlice({
  initialValues,
  reducers: {
    trainingDialogAppended: (state, action: PayloadAction<TrainingModal>) => {
      state.trainingModals = {
        ...state.trainingModals,
        [action.payload.id]: action.payload,
      };
    },
    trainingDialogRemoved: (state, action: PayloadAction<string>) => {
      delete state.trainingModals[action.payload];
    },
    currentIdSaved: (state, action: PayloadAction<string | undefined>) => {
      state.currentId = action.payload;
    },
  },
});

export const trainingSelectors = {
  selectCurrentId,
  selectTrainingModalId,
  selectTrainingModals,
};

export const {trainingDialogAppended, currentIdSaved, trainingDialogRemoved} =
  trainingSlice.actions;

export const {getInitialValues} = trainingSlice;
export default trainingSlice.reducer;
